<template>
    <div class="row roots">
        <div class="col-sm-6">
            <div class="card root">
                <div class="card-header text-white bg-dark">
                    Create Proxy
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Username</label>
                        <div class="input-group">
                            <input
                                v-model.trim="username"
                                :disabled="loading"
                                type="text"
                                class="form-control"
                            />
                            <div class="input-group-append">
                                <button
                                    :disabled="loading"
                                    class="btn btn-secondary"
                                    type="button"
                                    @click="randomUsername"
                                >
                                    Random
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Password</label>
                        <div class="input-group">
                            <input
                                v-model.trim="password"
                                :disabled="loading"
                                type="text"
                                class="form-control"
                            />
                            <div class="input-group-append">
                                <button
                                    :disabled="loading"
                                    class="btn btn-secondary"
                                    type="button"
                                    @click="randomPassword"
                                >
                                    Random
                                </button>
                            </div>
                        </div>
                        <small class="form-text text-muted"
                            >Only letters and numbers are allowed - case
                            sensitive - 3-30 long</small
                        >
                    </div>

                    <div class="form-group">
                        <label>Quota</label>
                        <div class="input-group">
                            <select v-model="quota" class="form-control">
                                <option
                                    v-for="quotaOpt in quotaOpts"
                                    :key="quotaOpt.value"
                                    :value="quotaOpt.value"
                                >
                                    {{ quotaOpt.label }}
                                </option>
                            </select>
                        </div>
                        <small class="form-text text-muted"
                            >Only <b>Reseller</b> plan or <b>above</b> can set
                            user quota</small
                        >
                    </div>

                    <div class="form-group">
                        <label>Region</label>
                        <div class="input-group">
                            <select v-model="region" class="form-control">
                                <option
                                    v-for="country in countries"
                                    :key="country.code"
                                    :value="country.code"
                                >
                                    {{ country.name }}
                                </option>
                            </select>
                        </div>
                        <small class="form-text text-muted">
                            FTL/SUP/SNKRS/SHOP proxies only live during release date (1-2 hours before)
                        </small>
                    </div>

                    <div class="form-group">
                        <label>Sticky</label>
                        <div class="input-group">
                            <select v-model="sticky" class="form-control">
                                <option
                                    v-for="stickyOpt in stickyOpts"
                                    :key="stickyOpt.value"
                                    :value="stickyOpt.value"
                                >
                                    {{ stickyOpt.label }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="card-footer text-right">
                    <div class="form-group">
                        <button
                            :disabled="loading"
                            class="btn btn-dark btn-margin"
                            @click="create"
                        >
                            Create
                        </button>
                        <br />
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                            <select
                                v-model="bulk"
                                :disabled="loading"
                                class="form-control"
                            >
                                <option>1</option>
                                <option>5</option>
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>50</option>
                                <option>75</option>
                                <option>100</option>
                            </select>

                            <div class="input-group-append">
                                <button
                                    :disabled="loading"
                                    class="btn btn-secondary"
                                    type="button"
                                    @click="createRandom"
                                >
                                    Create Random
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="card example">
                <div class="card-header text-white bg-secondary">
                    Usage examples
                </div>
                <div class="card-body">
                    <p><s>192.168.15.101:8808</s>:username:password</p>
                    <p>
                        user:pwd@
                        <s>192.168.15.101:8808</s>
                    </p>
                    <small class="form-text text-muted"
                        >Please refer to Proxy servers list for
                        <b>CORRECT</b> proxy server address</small
                    >
                </div>

                <div class="card-header text-white bg-danger">
                    Notes
                </div>
                <div class="card-body">
                    <ul>
                        <li>
                            You should use <b>1 rotating proxy</b> for all bot
                            tasks/sessions.
                        </li>
                        <li>
                            1 proxy = 1 <b>backconnect proxy</b> that rotates
                            proxy ip address <b>every requests</b> or
                            <b>1 min(Sticky)</b> or <b>10 min(Sticky)</b> for no
                            risk of ban.
                        </li>
                        <li>
                            After creating/updating a proxy,
                            <b>wait 1-2 min</b> for all servers to sync and
                            proxy to work.
                        </li>
                        <li>
                            If bot returns <b>407 error</b> it means invalid
                            login, double check your username and password.
                        </li>
                        <li>
                            <b>Browsers</b> don't support username/password
                            proxy, should test with bot or another tool.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { eventBus } from '../events'
import { config, auth, proxy, popup, handler, ad } from 'website-core'

const DEFAULT_COUNTRY = 'US'

export default {
    data() {
        return {
            countries: [],

            quotaOpts: proxy.quotas,
            stickyOpts: proxy.stickies,

            username: '',
            password: '',

            quota: 0,
            region: DEFAULT_COUNTRY,
            sticky: 0,

            loading: false,
            bulk: 1,
        }
    },
    async created() {
        this.countries = await ad.region.get()
    },
    methods: {
        randomUsername() {
            this.username = random()
        },
        randomPassword() {
            this.password = random()
        },
        createRandom() {
            for (let i = 0; i < this.bulk; i++) {
                this.randomUsername()
                this.randomPassword()
                this.create(true)
            }

            popup.showOK(
                'Please wait 1-2 min for all servers to sync and proxy to work'
            )
        },
        async create(bulk) {
            const username = this.username
            const password = this.password
            const quota = this.quota
            const region = this.region
            const sticky = this.sticky

            if (username === '' || password === '') {
                return
            }

            this.loading = true

            try {
                await ad.account.create({
                    username: username,
                    password: password,
                    quota: quota,
                    region: region,
                    sticky: sticky,
                })

                // send to account list component
                eventBus.$emit('newAccount', {
                    username: username,
                    password: password,
                    quota: quota,
                    region: region,
                    sticky: sticky,
                })

                this.username = ''
                if (!bulk) {
                    popup.showOK(
                        'Please wait 1-2 min for all servers to sync and proxy to work'
                    )
                }
                return
            } catch (err) {
                handler(err)
            } finally {
                this.loading = false
            }
        },
    },
}

// helper
function random() {
    return Math.random()
        .toString(36)
        .substr(2, 9)
}
</script>

<style scoped>
.roots {
    margin: 1rem 0;
}
.root,
.example {
    margin: 0.5rem 0;
}
</style>
